import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { reset, setPlaying, setSpeed } from "../slices/fleetSlice";
import playIcon from "../assets/play.png";
import pauseIcon from "../assets/pause.png";

export default function Controls() {
  const dispatch = useDispatch();
  const playing = useSelector((s: RootState) => s.fleet.playing);
  const speed = useSelector((s: RootState) => s.fleet.speed);

  return (
    <div className="flex items-center gap-2 mb-3">
      {/* Play / Pause */}
      <button
        onClick={() => dispatch(setPlaying(!playing))}
        aria-label={playing ? "Pause" : "Play"}
        className="
          inline-flex items-center justify-center gap-2
          h-9 px-3 w-[100px]
          max-[700px]:w-9 max-[700px]:px-0 max-[700px]:gap-0
          text-[14px] font-medium bg-white border border-gray-300 rounded-[6px]
        "
      >
        <img
          src={playing ? pauseIcon : playIcon}
          alt=""
          className="w-5 h-5 block shrink-0 object-contain"
        />
        <span className="max-[900px]:hidden">{playing ? "Pause" : "Play"}</span>
      </button>

      {/* Speed */}
      <select
        value={speed}
        onChange={(e) =>
          dispatch(setSpeed(Number(e.target.value) as 1 | 5 | 50 | 100 | 1000))
        }
        className="
          h-9 px-3 w-[96px] max-[700px]:w-[78px]
          text-[14px] font-medium bg-white border border-gray-300 rounded-[6px] leading-none
        "
        aria-label="Playback speed"
      >
        <option value={1}>1x</option>
        <option value={5}>5x</option>
        <option value={50}>50x</option>
        <option value={100}>100x</option>
        <option value={1000}>1000x</option>
      </select>

      {/* Reset */}
      <button
        onClick={() => dispatch(reset())}
        className="h-9 px-[10px] text-[14px] font-medium bg-white border-0 rounded-[6px] text-[#3b6ef6] hover:text-[#254eeb]"
      >
        Reset
      </button>
    </div>
  );
}
